
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface CampaignRule {
  id: string;
  campaign_id: string;
  rule_type: string;
  original_value: number | null;
  campaign_value: number;
  target_table: string;
  target_column: string;
  applied_at: string | null;
  reverted_at: string | null;
  created_at: string;
}

export const useCampaignRules = (campaignId?: string) => {
  return useQuery({
    queryKey: ['campaign-rules', campaignId],
    queryFn: async () => {
      if (!campaignId) return [];
      
      console.log('Fetching campaign rules for campaign:', campaignId);
      
      const { data, error } = await supabase
        .from('campaign_rules')
        .select('*')
        .eq('campaign_id', campaignId)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching campaign rules:', error);
        throw error;
      }

      return data as CampaignRule[];
    },
    enabled: !!campaignId,
  });
};
